import { topics } from "@/mocks/portal";

const featured = topics.filter((t) => t.wide);
const cards = topics.filter((t) => !t.wide);

function Meta({ t }: { t: (typeof topics)[number] }) {
  return (
    <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-400">
      <span className="inline-flex items-center gap-1 whitespace-nowrap">
        <i className="ri-folder-2-line text-primary-400"></i>
        {t.source}
      </span>
      <span className="inline-flex items-center gap-1 whitespace-nowrap">
        <i className="ri-eye-line"></i>
        {t.reads}
      </span>
    </div>
  );
}

export default function TopicGrid() {
  return (
    <section id="topics" className="scroll-mt-24 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              <i className="ri-file-list-3-line text-sm"></i>专题精选 · 大小卡混排
            </div>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              封面驱动 · 专题精选合集
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              以封面优先呈现检索结果，重点专题大图铺展，延伸专题小卡铺排，扫一眼即可锁定目标。
            </p>
          </div>
          <a
            href="#query"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            按关键词筛专题 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* 大卡（重点专题，对开） */}
        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
          {featured.map((t) => (
            <article
              key={t.id}
              className="group grid grid-cols-1 overflow-hidden rounded-xl border border-background-200/80 bg-background-50 transition-colors hover:border-primary-200 sm:grid-cols-2"
            >
              <a href="#query" className="relative block h-52 overflow-hidden sm:h-full">
                <img
                  src={t.cover}
                  alt={t.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded bg-background-950/70 px-2 py-0.5 text-[11px] font-semibold text-accent-200 backdrop-blur">
                  <i className="ri-fire-fill text-accent-300"></i>{t.kind}
                </span>
              </a>
              <div className="flex flex-col justify-center p-5 md:p-6">
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-2 py-0.5 text-[11px] font-semibold text-primary-700">
                    <i className="ri-price-tag-3-line text-xs"></i>{t.tag}
                  </span>
                  <span className="text-xs text-foreground-400">关键词导向检索</span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  <a href="#query">{t.title}</a>
                </h3>
                <p className="mt-2 text-[13px] leading-6 text-foreground-600">{t.summary}</p>
                <Meta t={t} />
              </div>
            </article>
          ))}
        </div>

        {/* 小卡（延伸专题，铺排） */}
        <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {cards.map((t) => (
            <article
              key={t.id}
              className="group overflow-hidden rounded-xl border border-background-200/80 bg-background-50 transition-all hover:-translate-y-1 hover:border-accent-300"
            >
              <a href="#query" className="relative block h-44 overflow-hidden md:h-48">
                <img
                  src={t.cover}
                  alt={t.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-108"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/35 to-transparent" />
                <span className="absolute right-3 top-3 rounded bg-background-50/90 px-2 py-0.5 text-[11px] font-semibold text-primary-700 backdrop-blur whitespace-nowrap">
                  {t.kind}
                </span>
                <span className="absolute bottom-3 left-3 inline-flex items-center gap-1 text-xs font-semibold text-background-50">
                  <i className="ri-eye-2-line"></i>{t.reads.split("次")[0]}
                </span>
              </a>
              <div className="p-4 md:p-5">
                <span className="inline-flex items-center gap-1 rounded-full bg-background-100 px-2 py-0.5 text-[11px] font-medium text-foreground-600">
                  <i className="ri-price-tag-3-line text-xs text-accent-600"></i>{t.tag}
                </span>
                <h3 className="mt-2.5 font-heading text-[15px] font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  <a href="#query">{t.title}</a>
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-5 text-foreground-500">{t.summary}</p>
                <Meta t={t} />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}